export const vertexShader = `
    uniform float uTime;
    uniform float uPixelRatio;
    attribute float aScale;
    attribute vec3 aRandomness;
    varying vec3 vColor;

    void main() {
        vec4 modelPosition = modelMatrix * vec4(position, 1.0);
        
        // Gentle floating movement
        float time = uTime * 0.2;
        modelPosition.x += sin(time + aRandomness.x * 100.0) * 0.2;
        modelPosition.y += cos(time + aRandomness.y * 100.0) * 0.2;
        modelPosition.z += sin(time + aRandomness.z * 100.0) * 0.2;

        vec4 viewPosition = viewMatrix * modelPosition;
        vec4 projectedPosition = projectionMatrix * viewPosition;

        gl_Position = projectedPosition;
        
        // Smooth organic twinkle
        float twinkle = sin(uTime * 2.0 + aRandomness.x * 100.0) * 0.5 + 0.5;
        float scale = aScale * (0.8 + twinkle * 0.5);
        
        gl_PointSize = scale * uPixelRatio * 60.0;
        gl_PointSize *= (1.0 / - viewPosition.z);

        vColor = vec3(1.0);
    }
`;

export const fragmentShader = `
    varying vec3 vColor;

    void main() {
        // Round soft star shape
        float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
        
        // Bright core with soft glow
        float strength = 0.05 / distanceToCenter - 0.1;
        
        gl_FragColor = vec4(vColor, strength);
    }
`;